import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var initialState = {
  popularData: {},
  isError: {},
  isFetching: {}
};
var changeStatus = function changeStatus(state, type, status, key) {
  return _defineProperty({}, key, Object.assign({}, state[key], _defineProperty({}, type, status)));
};
var changeIsFetchingStatus = function changeIsFetchingStatus(state, type, status) {
  return changeStatus(state, type, status, 'isFetching');
};
var changeIsErrorStatus = function changeIsErrorStatus(state, type, status) {
  return changeStatus(state, type, status, 'isError');
};
var getNewPopularData = function getNewPopularData(state, popularBrandsData, url) {
  if (!popularBrandsData) {
    return state.popularData;
  }
  var newPopularData = _defineProperty({}, url, popularBrandsData);
  return Object.assign({}, state.popularData, newPopularData);
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var url = action.url,
    data = action.data;
  switch (action.type) {
    case 'REQUEST_POPULAR_DATA':
      return Object.assign(Object.assign(Object.assign({}, state), changeIsFetchingStatus(state, url, true)), changeIsErrorStatus(state, url, false));
    case 'RECEIVE_POPULAR_DATA':
      var _ref2 = data || {},
        _ref2$data = _ref2.data,
        _ref2$data2 = _ref2$data === void 0 ? {} : _ref2$data,
        _ref2$data2$popularDa = _ref2$data2.popularDataItems,
        popularDataItems = _ref2$data2$popularDa === void 0 ? [] : _ref2$data2$popularDa;
      return Object.assign(Object.assign(Object.assign(Object.assign({}, state), {
        popularData: getNewPopularData(state, popularDataItems, url)
      }), changeIsFetchingStatus(state, url, false)), changeIsErrorStatus(state, url, false));
    case 'ERROR_POPULAR_DATA':
      return Object.assign(Object.assign(Object.assign({}, state), changeIsFetchingStatus(state, url, false)), changeIsErrorStatus(state, url, true));
    default:
      return state;
  }
});